$(function () {
    var eyeIcon            = FontAwesome.prefix('regular', 'eye');
    var eyeSlashIcon       = FontAwesome.prefix('regular', 'eye-slash');
    var passwordField      = $('#password');
    var togglePassword     = $('#toggle-password');
    var togglePasswordIcon = $('#toggle-password-icon');

    togglePassword.on('click', function () {
        var isPassword = passwordField.attr('type') === 'password';

        passwordField.attr('type', isPassword ? 'text' : 'password');
        togglePasswordIcon.toggleClass(`${eyeIcon} ${eyeSlashIcon}`);
    });
});
